<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Persona Picker"
    seFeDataSubtitle="Used to present user with a list of their profiles to select."
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
      <se-fe-card-content>
        <p>Use this component when a set of personas should be listed and selectable</p>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="PersonaPickerComponent"></se-fe-card-header>
      <se-fe-card-content>
        <se-fe-docs-table
          [seFeDataHeaders]="headers"
          [seFeDataRows]="personaPickerComponent">
        </se-fe-docs-table>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Persona Picker Example"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-persona-picker-example></se-po-persona-picker-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
